import React from 'react';
import './App.css';
import Home from './Home';
import Nav from './Nav';
import About from './About';
import Service from './Service';
import Cars from './Cars';
import Gallary from './Gallary';
import Shop from './Shop';
import Pages from './Pages';
import Contact from './Contact';
import Footer from './footer';

import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js';
import { BrowserRouter,Routes,Route } from 'react-router-dom';
import './App.css';



function App() {
  return (

    <BrowserRouter>
      <Nav />
      

       <Routes>
          <Route path="*" element={<Home />} />
         <Route index element={<Home />} />
         <Route path='Contact' element={<Contact/>}/>
         <Route path='Gallary' element={<Gallary/>}/>
         <Route path='About' element={<About/>}/>
         <Route path='Cars' element={<Cars/>}/>
         <Route path='Shop' element={<Shop/>}/>
         <Route path='Service' element={<Service/>}/>
         <Route path='Contact' element={<Contact/>}/>
         <Route path='Pages' element={<Pages/>}/>

       
       
      </Routes> 
     
      <Footer />
    </BrowserRouter>

  )

};

export default App;
